import { LoaderFunction } from "react-router-dom";
import { queryClient } from "../../queryClient";
import { freeFormQuery, publicAlgorithmQuery } from "./queries";
import { algorithmQuery } from "../AlgorithmBuilder/queries";

export const loader: (freeForm?: string) => LoaderFunction =
  (freeForm) =>
  async ({ params }) =>
    params.algorithmId === undefined
      ? await queryClient.fetchQuery(freeFormQuery(freeForm!))
      : await queryClient.fetchQuery(algorithmQuery(params.algorithmId));

export const publicLoader: LoaderFunction = async ({ params }) =>
  await queryClient.fetchQuery(publicAlgorithmQuery(params.algorithmId!));
